/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { OrganizationIdDto } from './OrganizationIdDto';
import {
    OrganizationIdDtoFromJSON,
    OrganizationIdDtoFromJSONTyped,
    OrganizationIdDtoToJSON,
} from './OrganizationIdDto';
import type { UserIdDto } from './UserIdDto';
import {
    UserIdDtoFromJSON,
    UserIdDtoFromJSONTyped,
    UserIdDtoToJSON,
} from './UserIdDto';

/**
 * 
 * @export
 * @interface AddUserDto
 */
export interface AddUserDto {
    /**
     * 
     * @type {OrganizationIdDto}
     * @memberof AddUserDto
     */
    organizationId: OrganizationIdDto;
    /**
     * 
     * @type {string}
     * @memberof AddUserDto
     */
    password: string;
    /**
     * 
     * @type {string}
     * @memberof AddUserDto
     */
    preferredEmail?: string;
    /**
     * 
     * @type {boolean}
     * @memberof AddUserDto
     */
    temporaryPassword?: boolean;
    /**
     * 
     * @type {UserIdDto}
     * @memberof AddUserDto
     */
    userId: UserIdDto;
}

/**
 * Check if a given object implements the AddUserDto interface.
 */
export function instanceOfAddUserDto(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "organizationId" in value;
    isInstance = isInstance && "password" in value;
    isInstance = isInstance && "userId" in value;

    return isInstance;
}

export function AddUserDtoFromJSON(json: any): AddUserDto {
    return AddUserDtoFromJSONTyped(json, false);
}

export function AddUserDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): AddUserDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'organizationId': OrganizationIdDtoFromJSON(json['organizationId']),
        'password': json['password'],
        'preferredEmail': !exists(json, 'preferredEmail') ? undefined : json['preferredEmail'],
        'temporaryPassword': !exists(json, 'temporaryPassword') ? undefined : json['temporaryPassword'],
        'userId': UserIdDtoFromJSON(json['userId']),
    };
}

export function AddUserDtoToJSON(value?: AddUserDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'organizationId': OrganizationIdDtoToJSON(value.organizationId),
        'password': value.password,
        'preferredEmail': value.preferredEmail,
        'temporaryPassword': value.temporaryPassword,
        'userId': UserIdDtoToJSON(value.userId),
    };
}

